p {
  margin: 0;
}

.link {
  color: rgb(30, 31, 77);
}

.input-container.phone {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.phone-country-dropdown {
  width: 78px;
}

.phone-country-dropdown .dropdown-button {
  gap: 0 !important;
}

.flag-container {
  font-size: 30px;
  line-height: 1;
}

.phone-country-dropdown .dropdown-button {
  padding-right: 0 !important;
  justify-content: flex-start;
  gap: 12px;
}

.phone-country-dropdown .input {
  border-right: none;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.phone-number-input {
  flex: 1;
  border-left: none !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.input-container.phone:focus-within .dropdown-button,
.input-container.phone:focus-within .phone-number-input {
  border-color: rgb(0, 95, 204);
}

.phone-number-input:focus {
  outline: none;
}

.skip-link {
  cursor: pointer;
}
